var _rect, _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaleRedBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 298,
    viewBox: "0 0 375 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_8691)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 298,
    fill: "#FF766F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_811_8691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -208,
    width: 535,
    height: 535
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 266.5,
    cy: 59.5,
    r: 267.5,
    fill: "url(#paint0_radial_811_8691)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_811_8691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.638 30.1587L216.594 34.2136",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.764 30.1587L231.807 34.2136",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.03 36.6931C213.03 34.6265 214.136 34.459 215.51 34.459H232.892C234.266 34.459 235.372 34.6265 235.372 36.6931C235.372 39.0948 234.266 38.9272 232.892 38.9272H215.51C214.136 38.9272 213.03 39.0948 213.03 36.6931Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.698 43.563V47.5286",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.837 43.563V47.5286",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.705 39.0947L216.28 48.7462C216.638 50.9133 217.498 52.4995 220.693 52.4995H227.428C230.903 52.4995 231.416 50.9803 231.819 48.8802L233.695 39.0947",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.27 14.5013L239.797 19.6665",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.994 12.1416L254.153 14.6288",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.255 23.1867C236.571 21.2367 237.559 20.7124 238.856 20.2574L255.257 14.5019C256.553 14.0469 257.652 13.8388 258.336 15.7888C259.132 18.055 258.033 18.2631 256.736 18.7181L240.335 24.4736C239.039 24.9286 238.051 25.4529 237.255 23.1867Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.709 26.7988L249.022 30.5407",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.558 25.0972L253.871 28.839",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.632 24.8975L244.314 33.4829C245.369 35.4093 246.706 36.6213 249.72 35.5634L256.076 33.3329C259.354 32.1825 259.336 30.5789 259.02 28.4641L257.551 18.6092",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.832 31.3262L205.824 25.5995",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.793 36.3657L195.066 36.3578",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.59 21.3265C208.051 22.7878 207.388 23.6882 206.416 24.6598L194.126 36.9504C193.154 37.922 192.254 38.5855 190.792 37.1242C189.094 35.4259 189.995 34.7624 190.966 33.7909L203.257 21.5003C204.228 20.5287 204.892 19.6282 206.59 21.3265Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.604 22.5977L192.799 19.7936",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.97 26.2314L189.166 23.4274",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.708 20.813L195.77 15.1021C193.985 13.8225 192.255 13.3091 189.996 15.5682L185.233 20.3312C182.776 22.7877 183.487 24.2253 184.688 25.9946L190.28 34.241",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.172 20.5416L222.83 19.6556",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.42 16.335L210.55 10.6748",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.17 19.7577C225.95 21.4258 224.959 20.9082 223.85 20.0971L209.82 9.83672C208.711 9.02564 207.917 8.23758 209.137 6.56948C210.555 4.63089 211.348 5.41895 212.457 6.23003L226.487 16.4905C227.597 17.3015 228.588 17.8191 227.17 19.7577Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.229 9.09521L226.569 5.89428",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.081 6.06201L222.422 2.86107",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.235 16.8296L231.661 8.10937C232.652 6.14911 232.894 4.36099 230.315 2.47508L224.878 -1.50117C222.074 -3.55193 220.762 -2.62899 219.198 -1.17123L211.907 5.61961",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.594 -4.69336L166.55 -0.63841",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72 -4.69336L181.764 -0.63841",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.986 1.84106C162.986 -0.225507 164.092 -0.393066 165.466 -0.393066H182.848C184.222 -0.393066 185.328 -0.225507 185.328 1.84106C185.328 4.24276 184.222 4.0752 182.848 4.0752H165.466C164.092 4.0752 162.986 4.24276 162.986 1.84106Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.654 8.71143V12.677",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.793 8.71143V12.677",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.661 4.24316L166.236 13.8946C166.594 16.0617 167.454 17.648 170.649 17.648H177.385C180.859 17.648 181.372 16.1287 181.775 14.0287L183.651 4.24316",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.588 -9.9541L194.27 -1.3687C195.325 0.557787 196.662 1.76971 199.676 0.711814L206.032 -1.51865C209.31 -2.66903 209.292 -4.27268 208.976 -6.38745L207.507 -16.2423",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.748 1.51367L145.021 1.50577",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.545 -13.5256C158.007 -12.0643 157.343 -11.1638 156.371 -10.1923L144.081 2.09835C143.109 3.06991 142.209 3.73341 140.748 2.27212C139.049 0.573872 139.95 -0.0896313 140.921 -1.06119L153.212 -13.3518C154.183 -14.3234 154.847 -15.2238 156.545 -13.5256Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.663 -14.0391L145.725 -19.7499C143.94 -21.0295 142.21 -21.543 139.951 -19.2839L135.188 -14.5209C132.731 -12.0643 133.442 -10.6268 134.643 -8.85742L140.235 -0.611021",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.174 93.0117L324.13 97.0667",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.3 93.0117L339.344 97.0667",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.566 99.5471C320.566 97.4805 321.672 97.313 323.046 97.313H340.428C341.802 97.313 342.908 97.4805 342.908 99.5471C342.908 101.949 341.802 101.781 340.428 101.781H323.046C321.672 101.781 320.566 101.949 320.566 99.5471Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.234 106.417V110.382",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.373 106.417V110.382",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.242 101.949L323.817 111.6C324.175 113.767 325.035 115.354 328.23 115.354H334.966C338.44 115.354 338.953 113.834 339.356 111.734L341.232 101.949",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.805 77.3548L347.332 82.52",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.53 74.9946L361.689 77.4818",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.792 86.0397C344.107 84.0897 345.095 83.5654 346.392 83.1105L362.793 77.3549C364.089 76.8999 365.188 76.6918 365.872 78.6418C366.668 80.908 365.569 81.1161 364.272 81.5711L347.871 87.3267C346.575 87.7816 345.587 88.3059 344.792 86.0397Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.245 89.6519L356.558 93.3937",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.094 87.9502L361.407 91.6921",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.167 87.7515L351.849 96.3369C352.904 98.2634 354.241 99.4753 357.255 98.4174L363.611 96.1869C366.889 95.0365 366.871 93.4329 366.555 91.3181L365.086 81.4632",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.367 94.1797L313.359 88.453",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.328 99.2192L302.601 99.2113",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.126 84.1795C315.588 85.6408 314.924 86.5413 313.953 87.5128L301.662 99.8034C300.69 100.775 299.79 101.438 298.329 99.9772C296.63 98.2789 297.531 97.6154 298.502 96.6439L310.793 84.3533C311.765 83.3817 312.428 82.4813 314.126 84.1795Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.139 85.4517L300.335 82.6476",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.505 89.085L296.701 86.2809",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.243 83.6665L303.305 77.9556C301.52 76.676 299.79 76.1626 297.531 78.4217L292.768 83.1847C290.311 85.6412 291.022 87.0788 292.223 88.8481L297.815 97.0945",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.709 83.3952L330.366 82.5092",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.956 79.1885L318.086 73.5283",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.707 82.6107C333.487 84.2788 332.495 83.7612 331.386 82.9502L317.356 72.6897C316.247 71.8787 315.453 71.0906 316.673 69.4225C318.091 67.4839 318.885 68.272 319.994 69.0831L334.024 79.3435C335.133 80.1546 336.124 80.6721 334.707 82.6107Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.765 71.9492L334.106 68.7483",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.617 68.9155L329.958 65.7146",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.771 79.6831L339.197 70.9629C340.188 69.0026 340.43 67.2145 337.851 65.3286L332.414 61.3523C329.61 59.3016 328.299 60.2245 326.734 61.6823L319.443 68.4731",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.889 94.501L110.845 98.5559",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.015 94.501L126.058 98.5559",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.281 101.036C107.281 98.9693 108.387 98.8018 109.761 98.8018H127.143C128.517 98.8018 129.623 98.9693 129.623 101.036C129.623 103.438 128.517 103.27 127.143 103.27H109.761C108.387 103.27 107.281 103.438 107.281 101.036Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.949 107.906V111.871",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.088 107.906V111.871",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.956 103.438L110.531 113.089C110.889 115.257 111.749 116.843 114.944 116.843H121.679C125.154 116.843 125.667 115.324 126.07 113.223L127.946 103.438",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.52 78.8441L134.047 84.0093",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 76.4844L148.403 78.9715",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.506 87.5295C130.822 85.5795 131.81 85.0552 133.107 84.6002L149.508 78.8447C150.804 78.3897 151.903 78.1816 152.587 80.1316C153.383 82.3978 152.284 82.6059 150.987 83.0608L134.586 88.8164C133.29 89.2714 132.302 89.7957 131.506 87.5295Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.96 91.1411L143.273 94.883",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.809 89.4399L148.122 93.1818",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.882 89.2402L138.564 97.8256C139.619 99.7521 140.956 100.964 143.97 99.9061L150.326 97.6757C153.604 96.5253 153.586 94.9217 153.27 92.8069L151.801 82.952",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.083 95.6685L100.075 89.9418",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.043 100.708L89.3163 100.701",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.841 85.6688C102.302 87.1301 101.639 88.0305 100.667 89.0021L88.3767 101.293C87.4052 102.264 86.5047 102.928 85.0434 101.466C83.3452 99.7682 84.2457 99.1047 85.2172 98.1331L97.5078 85.8425C98.4794 84.871 99.1429 83.9705 100.841 85.6688Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8535 86.9404L87.0494 84.1363",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2197 90.5742L83.4156 87.7701",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.958 85.1553L90.0197 79.4444C88.2345 78.1648 86.5047 77.6514 84.2456 79.9104L79.4826 84.6734C77.0261 87.13 77.737 88.5676 78.9376 90.3369L84.53 98.5833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.423 84.8849L117.081 83.9989",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.67 80.6782L104.8 75.0181",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.42 84.101C120.2 85.769 119.209 85.2515 118.1 84.4404L104.07 74.18C102.961 73.3689 102.167 72.5808 103.387 70.9127C104.805 68.9741 105.598 69.7622 106.707 70.5733L120.737 80.8337C121.847 81.6448 122.838 82.1624 121.42 84.101Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.479 73.4385L120.82 70.2375",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.332 70.4053L116.673 67.2043",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.486 81.1729L125.912 72.4526C126.903 70.4924 127.145 68.7043 124.566 66.8183L119.129 62.8421C116.325 60.7913 115.013 61.7143 113.449 63.172L106.158 69.9629",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.955 166.291L213.911 170.346",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.082 166.291L229.126 170.346",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.349 172.826C210.349 170.759 211.455 170.592 212.829 170.592H230.21C231.584 170.592 232.69 170.759 232.69 172.826C232.69 175.228 231.584 175.06 230.21 175.06H212.829C211.455 175.06 210.349 175.228 210.349 172.826Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.017 179.695V183.661",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.155 179.695V183.661",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.023 175.228L213.599 184.879C213.956 187.046 214.816 188.632 218.011 188.632H224.747C228.221 188.632 228.735 187.113 229.137 185.013L231.014 175.228",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.588 150.634L237.115 155.799",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.313 148.274L251.472 150.762",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.575 159.319C233.89 157.369 234.878 156.845 236.175 156.39L252.576 150.634C253.872 150.179 254.971 149.971 255.656 151.921C256.451 154.187 255.352 154.395 254.055 154.85L237.655 160.606C236.358 161.061 235.37 161.585 234.575 159.319Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.028 162.932L246.341 166.674",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.877 161.23L251.19 164.972",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.95 161.03L241.632 169.616C242.687 171.542 244.024 172.754 247.039 171.696L253.395 169.466C256.673 168.315 256.654 166.712 256.338 164.597L254.869 154.742",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.15 167.459L203.142 161.733",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.111 172.499L192.385 172.491",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.909 157.459C205.37 158.921 204.706 159.821 203.735 160.793L191.444 173.083C190.473 174.055 189.572 174.718 188.111 173.257C186.413 171.559 187.313 170.895 188.285 169.924L200.575 157.633C201.547 156.662 202.21 155.761 203.909 157.459Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.922 158.73L190.118 155.926",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.288 162.364L186.484 159.56",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.026 156.945L193.088 151.234C191.303 149.955 189.573 149.441 187.314 151.7L182.551 156.463C180.094 158.92 180.805 160.358 182.006 162.127L187.598 170.373",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.491 156.675L220.149 155.789",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.738 152.467L207.868 146.807",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.49 155.891C223.27 157.559 222.278 157.041 221.169 156.23L207.139 145.97C206.03 145.158 205.236 144.37 206.456 142.702C207.874 140.764 208.668 141.552 209.777 142.363L223.807 152.623C224.916 153.434 225.907 153.952 224.49 155.891Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.548 145.228L223.889 142.027",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4 142.195L219.741 138.994",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.555 152.963L228.981 144.243C229.971 142.282 230.213 140.494 227.635 138.608L222.198 134.632C219.393 132.581 218.082 133.504 216.517 134.962L209.226 141.753",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.616 59.0532L273.572 63.1082",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.742 59.0532L288.786 63.1082",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.009 65.5881C270.009 63.5216 271.115 63.354 272.489 63.354H289.87C291.244 63.354 292.35 63.5216 292.35 65.5881C292.35 67.9898 291.244 67.8223 289.87 67.8223H272.489C271.115 67.8223 270.009 67.9898 270.009 65.5881Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.677 72.458V76.4236",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.815 72.458V76.4236",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.685 67.9897L273.26 77.6412C273.617 79.8083 274.477 81.3945 277.672 81.3945H284.408C287.882 81.3945 288.396 79.8753 288.798 77.7752L290.675 67.9897",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.247 43.3963L296.774 48.5615",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.973 41.0361L311.131 43.5233",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.234 52.0812C293.55 50.1313 294.538 49.6069 295.834 49.152L312.235 43.3964C313.532 42.9414 314.631 42.7333 315.315 44.6833C316.11 46.9495 315.011 47.1576 313.715 47.6126L297.314 53.3682C296.017 53.8231 295.029 54.3474 294.234 52.0812Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.688 55.6934L306.001 59.4352",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.536 53.9922L310.849 57.7341",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.609 53.793L301.291 62.3784C302.346 64.3049 303.683 65.5168 306.698 64.4589L313.054 62.2284C316.332 61.078 316.314 59.4744 315.998 57.3596L314.528 47.5048",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.811 60.2212L262.803 54.4945",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.771 65.2603L252.044 65.2524",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.569 50.2215C265.03 51.6828 264.366 52.5833 263.395 53.5548L251.104 65.8454C250.133 66.817 249.232 67.4805 247.771 66.0192C246.073 64.3209 246.973 63.6574 247.945 62.6859L260.235 50.3953C261.207 49.4237 261.87 48.5232 263.569 50.2215Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.581 51.4927L249.777 48.6886",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.947 55.1265L246.143 52.3224",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.686 49.7075L252.747 43.9967C250.962 42.717 249.232 42.2036 246.973 44.4627L242.21 49.2257C239.754 51.6822 240.464 53.1198 241.665 54.8892L247.258 63.1356",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.15 49.4372L279.808 48.5511",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.397 45.2295L267.527 39.5694",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.148 48.6522C282.928 50.3203 281.936 49.8028 280.827 48.9917L266.797 38.7312C265.688 37.9202 264.895 37.1321 266.114 35.464C267.532 33.5254 268.326 34.3135 269.435 35.1246L283.465 45.385C284.574 46.1961 285.566 46.7136 284.148 48.6522Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.207 37.9902L283.548 34.7893",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.06 34.957L279.4 31.7561",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.213 45.7251L288.639 37.0049C289.63 35.0446 289.872 33.2565 287.293 31.3706L281.856 27.3943C279.052 25.3436 277.74 26.2665 276.176 27.7243L268.884 34.5151",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.798 1.81055L361.071 1.80265",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.595 -13.2287C374.056 -11.7674 373.393 -10.8669 372.421 -9.89538L360.131 2.39522C359.159 3.36678 358.259 4.03029 356.797 2.569C355.099 0.870747 356 0.207244 356.971 -0.764315L369.262 -13.0549C370.233 -14.0265 370.897 -14.9269 372.595 -13.2287Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.713 -13.7417L361.775 -19.4526C359.989 -20.7322 358.26 -21.2456 356 -18.9865L351.237 -14.2235C348.781 -11.767 349.492 -10.3294 350.692 -8.56005L356.285 -0.313658",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.347 123.075L370.339 117.349",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.308 128.114L359.581 128.106",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.105 113.075C372.566 114.536 371.903 115.437 370.931 116.408L358.64 128.699C357.669 129.67 356.768 130.334 355.307 128.873C353.609 127.174 354.509 126.511 355.481 125.539L367.771 113.249C368.743 112.277 369.407 111.377 371.105 113.075Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.118 114.347L357.314 111.543",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.484 117.98L353.68 115.176",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.222 112.562L360.283 106.851C358.498 105.572 356.768 105.058 354.509 107.317L349.746 112.08C347.29 114.537 348.001 115.974 349.201 117.744L354.794 125.99",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.935 108.083L375.064 102.423",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.685 111.506C390.465 113.174 389.474 112.657 388.364 111.846L374.334 101.585C373.225 100.774 372.432 99.9861 373.652 98.318C375.069 96.3794 375.863 97.1675 376.972 97.9786L391.002 108.239C392.111 109.05 393.103 109.568 391.685 111.506Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.75 108.579L396.176 99.8584C397.167 97.8981 397.409 96.11 394.83 94.2241L389.393 90.2479C386.589 88.1971 385.277 89.12 383.713 90.5778L376.422 97.3686",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.866 123.396L167.822 127.451",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.992 123.396L183.036 127.451",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.259 129.93C164.259 127.864 165.365 127.696 166.739 127.696H184.12C185.494 127.696 186.6 127.864 186.6 129.93C186.6 132.332 185.494 132.165 184.12 132.165H166.739C165.365 132.165 164.259 132.332 164.259 129.93Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.927 136.801V140.766",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.065 136.801V140.766",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.935 132.333L167.51 141.984C167.867 144.152 168.727 145.738 171.922 145.738H178.658C182.132 145.738 182.646 144.219 183.048 142.119L184.925 132.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.498 107.739L191.025 112.904",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.224 105.379L205.382 107.866",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.485 116.424C187.801 114.474 188.789 113.95 190.085 113.495L206.486 107.739C207.783 107.284 208.882 107.076 209.566 109.026C210.361 111.292 209.262 111.5 207.966 111.955L191.565 117.711C190.268 118.166 189.28 118.69 188.485 116.424Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.938 120.036L200.252 123.778",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.787 118.334L205.1 122.076",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.86 118.135L195.542 126.721C196.597 128.647 197.934 129.859 200.949 128.801L207.305 126.571C210.583 125.42 210.565 123.817 210.249 121.702L208.779 111.847",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.061 124.564L157.053 118.837",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.021 129.604L146.295 129.596",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.82 114.564C159.281 116.025 158.617 116.926 157.646 117.897L145.355 130.188C144.384 131.159 143.483 131.823 142.022 130.361C140.324 128.663 141.224 128 142.196 127.028L154.486 114.738C155.458 113.766 156.121 112.866 157.82 114.564Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.832 115.835L144.028 113.031",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.198 119.469L140.394 116.665",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.937 114.05L146.998 108.339C145.213 107.06 143.483 106.546 141.224 108.805L136.461 113.568C134.005 116.025 134.715 117.463 135.916 119.232L141.508 127.478",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.402 113.779L174.06 112.893",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.649 109.572L161.779 103.912",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 112.995C177.18 114.663 176.188 114.146 175.079 113.334L161.049 103.074C159.94 102.263 159.147 101.475 160.366 99.8068C161.784 97.8682 162.578 98.6563 163.687 99.4673L177.717 109.728C178.826 110.539 179.818 111.056 178.4 112.995Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.458 102.333L177.799 99.1321",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.311 99.2993L173.651 96.0984",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.465 110.067L182.891 101.347C183.882 99.3869 184.124 97.5988 181.545 95.7129L176.108 91.7366C173.304 89.6859 171.992 90.6088 170.428 92.0666L163.136 98.8574",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.935 195.186L270.892 199.241",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.062 195.186L286.105 199.241",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.328 201.721C267.328 199.655 268.434 199.487 269.808 199.487H287.19C288.564 199.487 289.669 199.655 289.669 201.721C289.669 204.123 288.564 203.956 287.19 203.956H269.808C268.434 203.956 267.328 204.123 267.328 201.721Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.996 208.591V212.556",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.135 208.591V212.556",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.004 204.123L270.579 213.774C270.936 215.942 271.797 217.528 274.991 217.528H281.727C285.201 217.528 285.715 216.009 286.117 213.909L287.994 204.123",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.567 179.53L294.094 184.695",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.292 177.169L308.45 179.657",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.552 188.215C290.868 186.265 291.856 185.741 293.152 185.286L309.553 179.53C310.85 179.075 311.949 178.867 312.633 180.817C313.428 183.083 312.329 183.291 311.033 183.746L294.632 189.502C293.336 189.957 292.348 190.481 291.552 188.215Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.007 191.827L303.32 195.569",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.855 190.125L308.169 193.867",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.929 189.926L298.611 198.512C299.666 200.438 301.003 201.65 304.017 200.592L310.373 198.362C313.651 197.211 313.633 195.608 313.317 193.493L311.847 183.638",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.129 196.355L260.121 190.628",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.09 201.394L249.363 201.386",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.887 186.354C262.348 187.816 261.685 188.716 260.713 189.688L248.423 201.978C247.451 202.95 246.551 203.613 245.089 202.152C243.391 200.454 244.292 199.79 245.263 198.819L257.554 186.528C258.525 185.557 259.189 184.656 260.887 186.354Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9 187.626L247.096 184.822",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.267 191.26L243.463 188.456",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.005 185.841L250.067 180.13C248.281 178.851 246.552 178.337 244.292 180.596L239.529 185.359C237.073 187.816 237.784 189.254 238.984 191.023L244.577 199.269",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.47 185.57L277.128 184.684",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.718 181.363L264.847 175.703",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.468 184.786C280.248 186.454 279.257 185.936 278.148 185.125L264.118 174.865C263.009 174.053 262.215 173.265 263.435 171.597C264.853 169.659 265.646 170.447 266.755 171.258L280.785 181.518C281.894 182.329 282.886 182.847 281.468 184.786Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.526 174.124L280.867 170.923",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.379 171.09L276.72 167.889",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.533 181.858L285.959 173.138C286.95 171.178 287.192 169.39 284.613 167.504L279.176 163.528C276.372 161.477 275.06 162.4 273.496 163.858L266.205 170.648",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38 90.9268L222.336 94.9817",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.506 90.9268L237.55 94.9817",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.772 97.4612C218.772 95.3946 219.878 95.2271 221.252 95.2271H238.634C240.008 95.2271 241.114 95.3946 241.114 97.4612C241.114 99.8629 240.008 99.6953 238.634 99.6953H221.252C219.878 99.6953 218.772 99.8629 218.772 97.4612Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.44 104.331V108.297",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.579 104.331V108.297",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.448 99.8628L222.023 109.514C222.381 111.681 223.241 113.268 226.436 113.268H233.172C236.646 113.268 237.16 111.748 237.562 109.648L239.438 99.8628",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.011 75.2689L245.538 80.4341",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.736 72.9092L259.895 75.3963",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.998 83.9538C242.313 82.0038 243.301 81.4795 244.598 81.0245L260.999 75.269C262.295 74.814 263.394 74.6059 264.079 76.5559C264.874 78.8221 263.775 79.0302 262.478 79.4852L246.077 85.2407C244.781 85.6957 243.793 86.22 242.998 83.9538Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.451 87.5664L254.764 91.3083",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 85.8647L259.613 89.6066",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.373 85.665L250.055 94.2504C251.11 96.1769 252.447 97.3889 255.461 96.331L261.817 94.1005C265.095 92.9501 265.077 91.3465 264.761 89.2317L263.292 79.3768",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.574 92.0942L211.566 86.3676",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.535 97.1338L200.808 97.1259",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.332 82.0941C213.794 83.5553 213.13 84.4558 212.159 85.4274L199.868 97.718C198.896 98.6895 197.996 99.353 196.535 97.8918C194.836 96.1935 195.737 95.53 196.708 94.5584L208.999 82.2678C209.971 81.2963 210.634 80.3958 212.332 82.0941Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.346 83.3662L198.542 80.5621",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.712 86.9995L194.908 84.1954",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.45 81.5811L201.512 75.8702C199.727 74.5906 197.997 74.0772 195.738 76.3362L190.975 81.0992C188.518 83.5558 189.229 84.9934 190.43 86.7627L196.022 95.0091",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.915 81.3102L228.572 80.4242",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.162 77.103L216.292 71.4429",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.912 80.5258C231.692 82.1939 230.7 81.6763 229.591 80.8652L215.561 70.6048C214.452 69.7937 213.658 69.0056 214.878 67.3375C216.296 65.399 217.09 66.187 218.199 66.9981L232.229 77.2585C233.338 78.0696 234.329 78.5872 232.912 80.5258Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.971 69.8638L232.312 66.6628",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.823 66.8306L228.164 63.6296",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.978 77.5981L237.403 68.8779C238.394 66.9177 238.636 65.1295 236.057 63.2436L230.62 59.2674C227.816 57.2166 226.505 58.1396 224.94 59.5973L217.649 66.3882",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.406 27.4775L331.362 31.5325",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.533 27.4775L346.577 31.5325",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.799 34.0129C327.799 31.9464 328.905 31.7788 330.279 31.7788H347.66C349.034 31.7788 350.14 31.9464 350.14 34.0129C350.14 36.4146 349.034 36.2471 347.66 36.2471H330.279C328.905 36.2471 327.799 36.4146 327.799 34.0129Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.467 40.8823V44.8479",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.605 40.8823V44.8479",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.475 36.4141L331.05 46.0655C331.407 48.2326 332.267 49.8189 335.462 49.8189H342.198C345.672 49.8189 346.186 48.2996 346.588 46.1996L348.465 36.4141",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.037 11.8197L354.564 16.9849",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.763 9.45996L368.921 11.9471",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.023 20.5051C351.339 18.5551 352.327 18.0308 353.623 17.5758L370.024 11.8202C371.321 11.3653 372.42 11.1572 373.104 13.1072C373.899 15.3734 372.8 15.5815 371.504 16.0364L355.103 21.792C353.806 22.247 352.818 22.7713 352.023 20.5051Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.478 24.1167L363.791 27.8586",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.326 22.416L368.639 26.1579",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.399 22.2163L359.082 30.8017C360.136 32.7282 361.473 33.9401 364.488 32.8822L370.844 30.6518C374.122 29.5014 374.104 27.8977 373.788 25.783L372.318 15.9281",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.6 28.6455L320.592 22.9189",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.561 33.6851L309.834 33.6772",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.359 18.6453C322.82 20.1066 322.156 21.0071 321.185 21.9786L308.894 34.2692C307.923 35.2408 307.022 35.9043 305.561 34.443C303.863 32.7448 304.763 32.0813 305.735 31.1097L318.025 18.8191C318.997 17.8475 319.66 16.9471 321.359 18.6453Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.371 19.917L307.567 17.1129",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.737 23.5503L303.933 20.7462",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.476 18.1323L310.537 12.4215C308.752 11.1418 307.022 10.6284 304.763 12.8875L300 17.6505C297.544 20.107 298.255 21.5446 299.455 23.314L305.048 31.5604",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.941 17.8605L337.599 16.9745",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.188 13.6538L325.318 7.99367",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.938 17.0765C340.718 18.7446 339.726 18.2271 338.617 17.416L324.587 7.15557C323.478 6.34449 322.685 5.55642 323.905 3.88833C325.322 1.94973 326.116 2.7378 327.225 3.54888L341.255 13.8093C342.364 14.6204 343.356 15.1379 341.938 17.0765Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.997 6.41455L341.338 3.21361",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.85 3.38135L337.191 0.18041",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.004 14.1489L346.43 5.42871C347.421 3.46845 347.663 1.68033 345.084 -0.205586L339.647 -4.18183C336.843 -6.2326 335.531 -5.30965 333.967 -3.85189L326.675 2.93895",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.916 153.78L329.872 157.835",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.043 153.78L345.087 157.835",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.309 160.315C326.309 158.249 327.414 158.081 328.788 158.081H346.17C347.544 158.081 348.65 158.249 348.65 160.315C348.65 162.717 347.544 162.549 346.17 162.549H328.788C327.414 162.549 326.309 162.717 326.309 160.315Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.977 167.186V171.151",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.115 167.186V171.151",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.984 162.717L329.559 172.368C329.917 174.535 330.777 176.122 333.972 176.122H340.708C344.182 176.122 344.696 174.602 345.098 172.502L346.974 162.717",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.547 138.123L353.074 143.288",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.272 135.763L367.431 138.25",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.534 146.808C349.849 144.858 350.837 144.334 352.134 143.879L368.535 138.123C369.831 137.668 370.93 137.46 371.615 139.41C372.41 141.677 371.311 141.885 370.014 142.34L353.614 148.095C352.317 148.55 351.329 149.074 350.534 146.808Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.987 150.42L362.3 154.162",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.836 148.719L367.149 152.461",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.909 148.519L357.591 157.104C358.646 159.031 359.983 160.243 362.998 159.185L369.354 156.954C372.632 155.804 372.613 154.2 372.297 152.086L370.828 142.231",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.11 154.948L319.102 149.222",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07 159.988L308.344 159.98",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.868 144.948C321.33 146.409 320.666 147.31 319.695 148.281L307.404 160.572C306.433 161.544 305.532 162.207 304.071 160.746C302.373 159.048 303.273 158.384 304.245 157.412L316.535 145.122C317.507 144.15 318.17 143.25 319.868 144.948Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.881 146.22L306.077 143.416",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.247 149.853L302.443 147.049",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.985 144.435L309.047 138.724C307.262 137.445 305.532 136.931 303.273 139.19L298.51 143.953C296.053 146.41 296.764 147.847 297.965 149.617L303.557 157.863",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.451 144.164L336.109 143.278",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.698 139.958L323.828 134.297",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.448 143.38C339.228 145.048 338.236 144.53 337.127 143.719L323.097 133.459C321.988 132.648 321.194 131.86 322.414 130.192C323.832 128.253 324.626 129.041 325.735 129.852L339.765 140.113C340.874 140.924 341.865 141.441 340.448 143.38Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.507 132.718L339.848 129.517",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.359 129.685L335.7 126.484",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.514 140.452L344.94 131.732C345.93 129.772 346.172 127.984 343.594 126.098L338.157 122.121C335.352 120.071 334.041 120.994 332.476 122.451L325.185 129.242",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.631 155.27L116.587 159.324",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.757 155.27L131.801 159.324",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.023 161.804C113.023 159.738 114.129 159.57 115.503 159.57H132.885C134.259 159.57 135.365 159.738 135.365 161.804C135.365 164.206 134.259 164.039 132.885 164.039H115.503C114.129 164.039 113.023 164.206 113.023 161.804Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.691 168.675V172.64",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.83 168.675V172.64",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.698 164.207L116.273 173.858C116.631 176.025 117.491 177.611 120.686 177.611H127.422C130.896 177.611 131.41 176.092 131.812 173.992L133.688 164.207",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.262 139.613L139.789 144.778",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.987 137.253L154.146 139.74",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.249 148.298C136.564 146.348 137.552 145.824 138.849 145.369L155.25 139.613C156.546 139.158 157.645 138.95 158.33 140.9C159.125 143.166 158.026 143.374 156.729 143.829L140.328 149.585C139.032 150.04 138.044 150.564 137.249 148.298Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.702 151.91L149.015 155.652",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.551 150.208L153.864 153.95",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.624 150.009L144.306 158.595C145.361 160.521 146.698 161.733 149.712 160.675L156.068 158.445C159.346 157.294 159.328 155.691 159.012 153.576L157.543 143.721",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.824 156.438L105.816 150.711",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.785 161.477L95.0585 161.469",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.582 146.437C108.044 147.899 107.38 148.799 106.409 149.771L94.118 162.061C93.1464 163.033 92.2459 163.696 90.7846 162.235C89.0864 160.537 89.9869 159.873 90.9584 158.902L103.249 146.611C104.221 145.64 104.884 144.739 106.582 146.437Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5957 147.709L92.7916 144.905",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9619 151.343L89.1578 148.539",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7 145.924L95.7619 140.213C93.9767 138.934 92.2469 138.42 89.9878 140.679L85.2248 145.442C82.7682 147.899 83.4791 149.337 84.6798 151.106L90.2722 159.352",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.165 145.653L122.822 144.767",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.412 141.447L110.542 135.787",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.163 144.87C125.943 146.538 124.951 146.02 123.842 145.209L109.812 134.949C108.703 134.137 107.909 133.349 109.129 131.681C110.547 129.743 111.341 130.531 112.45 131.342L126.48 141.602C127.589 142.413 128.58 142.931 127.163 144.87Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.222 134.207L126.563 131.006",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.074 131.174L122.415 127.973",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.229 141.941L131.654 133.221C132.645 131.261 132.887 129.473 130.308 127.587L124.871 123.611C122.067 121.56 120.756 122.483 119.191 123.941L111.9 130.731",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.699 227.06L219.655 231.115",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.825 227.06L234.869 231.115",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.092 233.595C216.092 231.528 217.198 231.361 218.572 231.361H235.953C237.327 231.361 238.433 231.528 238.433 233.595C238.433 235.997 237.327 235.829 235.953 235.829H218.572C217.198 235.829 216.092 235.997 216.092 233.595Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.76 240.465V244.43",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.898 240.465V244.43",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.767 235.997L219.342 245.648C219.699 247.815 220.559 249.401 223.754 249.401H230.49C233.964 249.401 234.478 247.882 234.88 245.782L236.757 235.997",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.331 211.403L242.858 216.568",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.057 209.043L257.215 211.531",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.318 220.089C239.634 218.139 240.622 217.614 241.918 217.159L258.319 211.404C259.616 210.949 260.715 210.741 261.399 212.691C262.194 214.957 261.095 215.165 259.799 215.62L243.398 221.375C242.101 221.83 241.113 222.355 240.318 220.089Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.771 223.701L252.085 227.443",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62 222L256.933 225.741",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.693 221.8L247.375 230.385C248.43 232.312 249.767 233.524 252.782 232.466L259.138 230.235C262.416 229.085 262.398 227.481 262.082 225.366L260.612 215.512",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.894 228.227L208.886 222.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.854 233.267L198.128 233.259",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.652 218.228C211.113 219.689 210.449 220.59 209.478 221.561L197.187 233.852C196.216 234.823 195.315 235.487 193.854 234.026C192.156 232.327 193.056 231.664 194.028 230.692L206.318 218.402C207.29 217.43 207.953 216.53 209.652 218.228Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.665 219.499L195.861 216.695",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.031 223.133L192.227 220.329",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.77 217.714L198.831 212.003C197.046 210.723 195.316 210.21 193.057 212.469L188.294 217.232C185.838 219.689 186.548 221.126 187.749 222.896L193.341 231.142",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.234 217.444L225.892 216.558",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.481 213.237L213.611 207.577",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.232 216.66C229.012 218.328 228.02 217.81 226.911 216.999L212.881 206.739C211.772 205.927 210.979 205.139 212.198 203.471C213.616 201.533 214.41 202.321 215.519 203.132L229.549 213.392C230.658 214.203 231.65 214.721 230.232 216.66Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.291 205.998L229.632 202.797",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.144 202.964L225.484 199.763",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.298 213.732L234.724 205.012C235.715 203.051 235.957 201.263 233.378 199.377L227.941 195.401C225.137 193.35 223.825 194.273 222.261 195.731L214.969 202.522",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.739 61.436L157.695 65.491",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.865 61.436L172.909 65.491",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.132 67.9714C154.132 65.9049 155.238 65.7373 156.612 65.7373H173.993C175.367 65.7373 176.473 65.9049 176.473 67.9714C176.473 70.3731 175.367 70.2056 173.993 70.2056H156.612C155.238 70.2056 154.132 70.3731 154.132 67.9714Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8 74.8408V78.8064",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.938 74.8408V78.8064",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.808 70.373L157.383 80.0245C157.74 82.1916 158.6 83.7778 161.795 83.7778H168.531C172.005 83.7778 172.519 82.2586 172.921 80.1585L174.798 70.373",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.37 45.7796L180.897 50.9448",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.096 43.4194L195.254 45.9066",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.357 54.465C177.673 52.515 178.661 51.9907 179.957 51.5358L196.358 45.7802C197.655 45.3252 198.754 45.1171 199.438 47.0671C200.233 49.3333 199.134 49.5414 197.838 49.9964L181.437 55.752C180.14 56.2069 179.152 56.7312 178.357 54.465Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.811 58.0767L190.124 61.8185",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.659 56.375L194.972 60.1169",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.732 56.1763L185.415 64.7617C186.469 66.6882 187.806 67.9001 190.821 66.8422L197.177 64.6117C200.455 63.4613 200.437 61.8577 200.121 59.7429L198.651 49.8881",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.933 62.6045L146.925 56.8778",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.894 67.644L136.167 67.6361",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.691 52.6043C149.152 54.0656 148.489 54.9661 147.517 55.9376L135.226 68.2282C134.255 69.1998 133.354 69.8633 131.893 68.402C130.195 66.7038 131.095 66.0403 132.067 65.0687L144.357 52.7781C145.329 51.8065 145.992 50.9061 147.691 52.6043Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.704 53.876L133.9 51.0719",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.07 57.5098L130.266 54.7057",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.809 52.0913L136.87 46.3804C135.085 45.1008 133.355 44.5874 131.096 46.8465L126.333 51.6095C123.877 54.066 124.588 55.5036 125.788 57.273L131.381 65.5193",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.273 51.8205L163.931 50.9344",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.521 47.6128L151.65 41.9527",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.271 51.0355C167.051 52.7036 166.059 52.1861 164.95 51.375L150.92 41.1146C149.811 40.3035 149.018 39.5154 150.238 37.8473C151.655 35.9087 152.449 36.6968 153.558 37.5079L167.588 47.7683C168.697 48.5794 169.689 49.0969 168.271 51.0355Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.33 40.3735L167.671 37.1726",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.182 37.3403L163.523 34.1394",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.337 48.1084L172.763 39.3882C173.754 37.4279 173.996 35.6398 171.417 33.7539L165.98 29.7776C163.176 27.7269 161.864 28.6498 160.3 30.1076L153.008 36.8984",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.694 26.584L107.65 30.6389",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82 26.584L122.864 30.6389",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.087 33.1189C104.087 31.0523 105.193 30.8848 106.567 30.8848H123.948C125.322 30.8848 126.428 31.0523 126.428 33.1189C126.428 35.5206 125.322 35.353 123.948 35.353H106.567C105.193 35.353 104.087 35.5206 104.087 33.1189Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.755 39.9888V43.9544",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.894 39.9888V43.9544",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.763 35.5205L107.338 45.172C107.695 47.3391 108.555 48.9253 111.75 48.9253H118.486C121.96 48.9253 122.474 47.4061 122.876 45.306L124.753 35.5205",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.326 10.9266L130.853 16.0918",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.052 8.56641L145.21 11.0536",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.313 19.612C127.629 17.662 128.617 17.1377 129.913 16.6827L146.314 10.9272C147.611 10.4722 148.71 10.2641 149.394 12.2141C150.189 14.4803 149.09 14.6884 147.794 15.1434L131.393 20.8989C130.096 21.3539 129.108 21.8782 128.313 19.612Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.767 23.2236L140.08 26.9655",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.615 21.522L144.928 25.2638",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.688 21.3232L135.371 29.9086C136.425 31.8351 137.762 33.0471 140.777 31.9892L147.133 29.7587C150.411 28.6083 150.393 27.0047 150.077 24.8899L148.607 15.035",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8896 27.7515L96.8817 22.0248",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8496 32.791L86.1229 32.7831",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6478 17.7523C99.1091 19.2135 98.4456 20.114 97.474 21.0856L85.1834 33.3762C84.2118 34.3477 83.3114 35.0112 81.8501 33.55C80.1518 31.8517 81.0523 31.1882 82.0238 30.2166L94.3145 17.926C95.286 16.9545 95.9495 16.054 97.6478 17.7523Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6602 19.0234L83.8561 16.2193",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0273 22.6572L80.2233 19.8531",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7646 17.2383L86.8263 11.5274C85.0412 10.2478 83.3113 9.73438 81.0522 11.9934L76.2892 16.7565C73.8327 19.213 74.5436 20.6506 75.7442 22.4199L81.3366 30.6663",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23 16.9669L113.888 16.0809",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.478 12.7603L101.607 7.10012",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.228 16.1825C117.008 17.8506 116.017 17.333 114.907 16.5219L100.877 6.26152C99.7684 5.45045 98.9746 4.66238 100.195 2.99429C101.612 1.05569 102.406 1.84376 103.515 2.65483L117.545 12.9153C118.654 13.7263 119.646 14.2439 118.228 16.1825Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.286 5.521L117.627 2.32006",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.139 2.4873L113.48 -0.713633",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.293 13.2554L122.719 4.53515C123.71 2.57489 123.952 0.786773 121.373 -1.09914L115.936 -5.07539C113.132 -7.12615 111.82 -6.20321 110.256 -4.74545L102.965 2.04539",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.765 -2.01318L266.722 2.04177",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.892 -2.01318L281.935 2.04177",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.158 4.52173C263.158 2.45516 264.264 2.2876 265.638 2.2876H283.02C284.394 2.2876 285.5 2.45516 285.5 4.52173C285.5 6.92342 284.394 6.75586 283.02 6.75586H265.638C264.264 6.75586 263.158 6.92342 263.158 4.52173Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.826 11.3916V15.3572",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.965 11.3916V15.3572",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.834 6.92334L266.409 16.5748C266.767 18.7419 267.627 20.3281 270.821 20.3281H277.557C281.031 20.3281 281.545 18.8089 281.947 16.7088L283.824 6.92334",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.759 -7.27393L294.441 1.31148C295.496 3.23796 296.833 4.44989 299.847 3.39199L306.203 1.16152C309.481 0.0111473 309.463 -1.59251 309.147 -3.70728L307.678 -13.5621",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.959 -0.845695L255.951 -6.57236",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92 4.19385L245.193 4.18595",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.717 -10.8449C258.178 -9.38362 257.515 -8.48315 256.543 -7.51159L244.253 4.77901C243.281 5.75057 242.381 6.41407 240.919 4.95279C239.221 3.25454 240.122 2.59103 241.093 1.61947L253.384 -10.6711C254.355 -11.6427 255.019 -12.5432 256.717 -10.8449Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.834 -11.3589L245.896 -17.0698C244.111 -18.3494 242.381 -18.8628 240.122 -16.6037L235.359 -11.8407C232.902 -9.38417 233.613 -7.94658 234.814 -6.17724L240.406 2.06915",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.275 127.566L265.231 131.621",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.402 127.566L280.446 131.621",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.668 134.101C261.668 132.034 262.774 131.867 264.148 131.867H281.529C282.903 131.867 284.009 132.034 284.009 134.101C284.009 136.503 282.903 136.335 281.529 136.335H264.148C262.774 136.335 261.668 136.503 261.668 134.101Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.336 140.971V144.936",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.475 140.971V144.936",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.344 136.502L264.919 146.154C265.276 148.321 266.136 149.907 269.331 149.907H276.067C279.541 149.907 280.055 148.388 280.457 146.288L282.334 136.502",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.906 111.91L288.434 117.075",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.632 109.55L302.79 112.037",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.892 120.595C285.208 118.645 286.196 118.121 287.492 117.666L303.893 111.91C305.19 111.455 306.289 111.247 306.973 113.197C307.768 115.463 306.669 115.671 305.373 116.126L288.972 121.882C287.675 122.337 286.687 122.861 285.892 120.595Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.347 124.207L297.66 127.949",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.195 122.505L302.508 126.247",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.269 122.306L292.951 130.892C294.006 132.818 295.342 134.03 298.357 132.972L304.713 130.742C307.991 129.591 307.973 127.988 307.657 125.873L306.187 116.018",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.469 128.734L254.461 123.008",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.43 133.774L243.703 133.766",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.228 118.734C256.689 120.195 256.026 121.096 255.054 122.068L242.763 134.358C241.792 135.33 240.891 135.993 239.43 134.532C237.732 132.834 238.632 132.17 239.604 131.199L251.895 118.908C252.866 117.936 253.53 117.036 255.228 118.734Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.24 120.006L241.436 117.202",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.606 123.64L237.802 120.836",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.345 118.221L244.406 112.51C242.621 111.231 240.891 110.717 238.632 112.976L233.869 117.739C231.413 120.196 232.124 121.633 233.324 123.403L238.917 131.649",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.81 117.95L271.468 117.064",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.058 113.743L259.187 108.083",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.808 117.166C274.588 118.834 273.597 118.316 272.488 117.505L258.458 107.245C257.348 106.434 256.555 105.646 257.775 103.978C259.192 102.039 259.986 102.827 261.095 103.638L275.125 113.899C276.234 114.71 277.226 115.227 275.808 117.166Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.866 106.503L275.207 103.302",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.719 103.47L271.06 100.269",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.873 114.238L280.299 105.518C281.29 103.557 281.532 101.769 278.953 99.8833L273.516 95.907C270.712 93.8563 269.4 94.7792 267.836 96.237L260.545 103.028",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.836 62.6045L371.828 56.8778",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.797 67.644L361.07 67.6361",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.594 52.6043C374.055 54.0656 373.392 54.9661 372.42 55.9376L360.13 68.2282C359.158 69.1998 358.258 69.8633 356.796 68.402C355.098 66.7038 355.999 66.0403 356.97 65.0687L369.261 52.7781C370.232 51.8065 370.896 50.9061 372.594 52.6043Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.607 53.876L358.803 51.0719",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.974 57.5098L355.17 54.7057",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.712 52.0913L361.774 46.3804C359.988 45.1008 358.259 44.5874 356 46.8465L351.237 51.6095C348.78 54.066 349.491 55.5036 350.691 57.273L356.284 65.5193",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.425 47.6128L376.554 41.9527",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.174 51.0355C391.954 52.7036 390.963 52.1861 389.854 51.375L375.824 41.1146C374.715 40.3035 373.921 39.5154 375.141 37.8473C376.559 35.9087 377.352 36.6968 378.461 37.5079L392.491 47.7683C393.6 48.5794 394.592 49.0969 393.174 51.0355Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9901 125.779L51.9463 129.834",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1172 125.779L67.161 129.834",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3828 132.314C48.3828 130.248 49.4887 130.08 50.8627 130.08H68.2442C69.6182 130.08 70.7241 130.248 70.7241 132.314C70.7241 134.716 69.6182 134.548 68.2442 134.548H50.8627C49.4887 134.548 48.3828 134.716 48.3828 132.314Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0508 139.184V143.15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1895 139.184V143.15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0586 134.715L51.6337 144.367C51.9911 146.534 52.8513 148.12 56.0461 148.12H62.782C66.256 148.12 66.7699 146.601 67.172 144.501L69.0487 134.715",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6213 110.122L75.1484 115.287",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3467 107.763L89.505 110.25",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.608 118.808C71.9236 116.858 72.9117 116.334 74.2081 115.879L90.6091 110.123C91.9056 109.668 93.0046 109.46 93.6889 111.41C94.4842 113.676 93.3852 113.884 92.0887 114.339L75.6877 120.095C74.3913 120.55 73.4032 121.074 72.608 118.808Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0615 122.42L84.3747 126.162",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9102 120.718L89.2233 124.46",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9834 120.519L79.6655 129.104C80.7204 131.031 82.0573 132.243 85.0718 131.185L91.4277 128.954C94.7058 127.804 94.6876 126.2 94.3717 124.086L92.9022 114.231",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1846 126.946L41.1767 121.22",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1445 131.986L30.4179 131.978",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9427 116.947C43.404 118.408 42.7405 119.309 41.7689 120.28L29.4783 132.571C28.5068 133.543 27.6063 134.206 26.145 132.745C24.4467 131.047 25.3472 130.383 26.3188 129.411L38.6094 117.121C39.5809 116.149 40.2444 115.249 41.9427 116.947Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9551 118.218L28.151 115.414",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3223 121.852L24.5182 119.048",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0596 116.433L31.1212 110.722C29.3361 109.443 27.6062 108.929 25.3472 111.188L20.5842 115.951C18.1276 118.408 18.8385 119.845 20.0391 121.615L25.6315 129.861",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.525 116.162L58.1827 115.276",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7725 111.955L45.9021 106.295",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5229 115.378C61.303 117.046 60.3114 116.529 59.2024 115.718L45.1724 105.457C44.0633 104.646 43.2696 103.858 44.4895 102.19C45.9072 100.251 46.7009 101.04 47.81 101.851L61.84 112.111C62.9491 112.922 63.9407 113.44 62.5229 115.378Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5811 104.716L61.922 101.515",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4336 101.683L57.7745 98.4817",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5879 112.451L67.0138 103.73C68.0046 101.77 68.2466 99.9821 65.6678 98.0962L60.2308 94.1199C57.4266 92.0692 56.115 92.9921 54.5507 94.4499L47.2595 101.241",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.058 197.569L155.015 201.624",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.185 197.569L170.228 201.624",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.451 204.104C151.451 202.038 152.557 201.87 153.931 201.87H171.313C172.687 201.87 173.792 202.038 173.792 204.104C173.792 206.506 172.687 206.338 171.313 206.338H153.931C152.557 206.338 151.451 206.506 151.451 204.104Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.119 210.974V214.94",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.258 210.974V214.94",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.127 206.505L154.702 216.157C155.059 218.324 155.92 219.91 159.114 219.91H165.85C169.324 219.91 169.838 218.391 170.24 216.291L172.117 206.505",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.69 181.912L178.217 187.078",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.415 179.552L192.573 182.039",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.676 190.597C174.992 188.647 175.98 188.123 177.277 187.668L193.677 181.913C194.974 181.458 196.073 181.249 196.757 183.199C197.553 185.466 196.454 185.674 195.157 186.129L178.756 191.884C177.46 192.339 176.472 192.864 175.676 190.597Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.13 194.209L187.443 197.951",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.979 192.508L192.292 196.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.052 192.309L182.734 200.894C183.789 202.821 185.126 204.033 188.14 202.975L194.496 200.745C197.774 199.594 197.756 197.991 197.44 195.876L195.971 186.021",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.252 198.737L144.244 193.011",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.213 203.776L133.486 203.768",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.01 188.737C146.471 190.198 145.808 191.099 144.836 192.07L132.546 204.361C131.574 205.333 130.674 205.996 129.212 204.535C127.514 202.837 128.415 202.173 129.386 201.202L141.677 188.911C142.648 187.939 143.312 187.039 145.01 188.737Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.023 190.009L131.219 187.205",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.39 193.642L127.586 190.838",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.128 188.224L134.19 182.513C132.404 181.233 130.675 180.72 128.416 182.979L123.653 187.742C121.196 190.198 121.907 191.636 123.108 193.405L128.7 201.652",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.593 187.953L161.251 187.067",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.841 183.746L148.97 178.085",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.591 187.168C164.371 188.836 163.38 188.319 162.271 187.508L148.241 177.247C147.132 176.436 146.338 175.648 147.558 173.98C148.976 172.042 149.769 172.83 150.878 173.641L164.908 183.901C166.017 184.712 167.009 185.23 165.591 187.168Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.649 176.506L164.99 173.305",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.502 173.473L160.843 170.272",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.656 184.241L170.082 175.521C171.073 173.56 171.315 171.772 168.736 169.886L163.299 165.91C160.495 163.859 159.183 164.782 157.619 166.24L150.328 173.031",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_811_8691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.5 59.5) rotate(90) scale(267.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#D9D9D9",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#D9D9D9",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_8691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 298,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleRedBackground);
export default __webpack_public_path__ + "static/media/sale-red-background.2eba2752642116deea5fbfbd3f22f350.svg";
export { ForwardRef as ReactComponent };